import moment from "moment";
import api from "../../../api";
import { getCurrentUserRole } from "modules/utilities/utility";
import secureLocalStorage from "react-secure-storage";

export function putBreakDays(id, breaks) {
  return api.put(`user/${id}/edit`, {
    user: {
      meta: {
        bio: { description: "" },
        shifts: [],
        breakWeekDays: breaks,
        limechat_user_id: "",
      },
    },
  });
}

export function getOverDueTasks(id, start, end) {
  return api.get(
    `v2/engagements?rep_id=${id}&tag=SLOT_BOOKING&start_date=${start}&end_date=${end}&state=active`
  );
}

export function getMedRepBooking(id, start, end) {
  return api.get(
    `v2/engagements?rep_id=${id}&tag=SLOT_BOOKING&start_date=${start}&end_date=${end}&state=active`
  );
}

export function getIVRBookings(start, end) {
  if (getCurrentUserRole() == "medical") {
    return api.get(
      `v2/engagements?rep_id=${secureLocalStorage.getItem('id')}&tag=SLOT_BOOKING_MEDICAL&start_date=${start.toISOString()}&end_date=${end.toISOString()}&state=active`
    );
  } else {
    return api.get(
      `v2/engagements?tag=IVR_BOOKING&start_date=${start}&end_date=${end}&state=active`
    );
  }
}
